import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import moment from "moment";
import { useParams } from "react-router-dom";
import LabTestReportFormPage from "./LabTestReportFormPage";
import { FETCH_LAB_TEST_REPORT } from "./graphql";

const LabTestReportLoader = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(FETCH_LAB_TEST_REPORT, {
    variables: { id },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const report = data?.labTestReport;
  const initialValues = {
    title: report?.title || "",
    country: report?.country || "CN",
    issuer: report?.issuer || "",
    issuedDate: report?.issuedDate
      ? moment(report.issuedDate).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD"),
    reportNumber: report?.reportNumber || "",
    validityMonths:
      report?.validityMonths === null || report?.validityMonths === undefined
        ? "24"
        : String(report.validityMonths),
    validUntil: report?.validUntil
      ? moment(report.validUntil).format("YYYY-MM-DD")
      : "",
  };

  return (
    <LabTestReportFormPage
      mode="edit"
      id={id}
      initialValues={initialValues}
      initialProducts={report?.products || []}
      initialStandards={report?.standards || []}
      initialFiles={report?.fileUrls || []}
    />
  );
};

export default LabTestReportLoader;
